import { render, staticRenderFns } from "./HotspotQuestion.vue?vue&type=template&id=16236484&scoped=true"
import script from "./HotspotQuestion.vue?vue&type=script&lang=js"
export * from "./HotspotQuestion.vue?vue&type=script&lang=js"
import style0 from "./HotspotQuestion.vue?vue&type=style&index=0&id=16236484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16236484",
  null
  
)

export default component.exports